<template>

    <section id="booking-list">
        <h2>Afventer godkendelse</h2>
        <ul class="gridlist">
            <li v-for="b in bookings" class="card" :key="b.pk">
                <booking :data="b" />
                <accept-reject :booking="b" v-on:booking-updated="fetchBookings()" />
            </li>
        </ul>
        <p v-if="bookings.length < 1">
            Der er ingen reservationer, som skal godkendes
        </p>
    </section>

</template>

<script>

    import axios from '../../utils/Http.js'
    import AcceptReject from '../booking/AcceptReject.vue'
    import { displayDjangoDate, dateJs2django, sortBookings } from '../../utils/Filters.js'
    import booking from '../booking/BookingMini.vue'
    
    export default {

        components: {
            AcceptReject,
            booking
        },
        data: function() {
            return {
                bookings: []
            }
        },
        computed: {
            user: function() {
                return this.$store.getters.getUser
            }
        },
        filters: {
            prettyDate: function(date_str) {
                return displayDjangoDate(date_str)
            }
        },
        methods: {
            fetchBookings: function() {
                let now = encodeURIComponent(dateJs2django( new Date() )),
                    months_from_now = encodeURIComponent( dateJs2django( new Date(new Date().setMonth(new Date().getMonth() + 6)) ))
                axios({
                    method: 'get',
                    url: `/booking/booking?status=0&from=${ now }&to=${ months_from_now }`,
                    headers: {
                        'Authorization': 'Token ' + this.$store.state.auth.sessionKey
                    }
                })
                .then(res => {
                    this.bookings = sortBookings(res.data)
                })
                .catch(err => console.log(err))
            }
        },
        created: function() {
            this.fetchBookings()
        }
        
    }

</script>

<style lang="scss">

    #booking-list {
        
        .reservation {
            padding-bottom: .5rem;
        }
    }

</style>
